import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule, NotAuthGuard, Occ, OccSiteAdapter, UrlModule } from '@spartacus/core';
import {
  FormErrorsModule,
  PageComponentModule,
  PageLayoutModule,
  PageSlotModule,
  SpinnerModule,
} from '@spartacus/storefront';
import { LoginModule } from '@spartacus/user/account/components';
import { knBrUserRegisterEndpointsConfig } from 'src/feature-libs/kn-br-user/kn-br-account/components/kn-br-user-register/kn-br-user-register-endpoints.config';
import { KnBrUserRegisterComponent } from 'src/feature-libs/kn-br-user/kn-br-account/components/kn-br-user-register/kn-br-user-register.component';
//import { USER_SIGN_UP_SERIALIZER } from '@spartacus/user/profile/core';
import { USER_SIGN_UP_SERIALIZER } from 'src/feature-libs/kn-br-user/kn-br-profile/core/connectors/converters';
import { KnBrUserSignUpSerializer } from 'src/serializer/kn-br-user-signup.serializer';
import { AtgUserRegisterComponent } from './atg-user-register/atg-user-register.component';


@NgModule({
  imports: [
    CommonModule,
    LoginModule,
    ReactiveFormsModule,
    NgSelectModule,
    RouterModule,
    UrlModule,
    I18nModule,
    SpinnerModule,
    FormErrorsModule,
    PageComponentModule,
    PageLayoutModule,
    PageSlotModule,
    ConfigModule.withConfig({
      cmsComponents: {
        RegisterCustomerComponent: {
          component: () => import('./atg-user-register/atg-user-register.component').then((c) => c.AtgUserRegisterComponent),
          guards: [NotAuthGuard],
        },
      },
    } as CmsConfig),
    ConfigModule.withConfig(knBrUserRegisterEndpointsConfig),
  ],
  providers: [
    {
      provide: USER_SIGN_UP_SERIALIZER,
      useClass: KnBrUserSignUpSerializer,
      multi: true,
    },
    OccSiteAdapter
  ],
  declarations: [AtgUserRegisterComponent],
  exports: [AtgUserRegisterComponent],
})
export class AtgUserRegisterModule { }
